function Swipe(elem, callback) {
  var self = this;
  this.callback = callback;

  function handleEvent(e) {
    self.touchHandler(e);
  }

  elem.addEventListener("touchstart", handleEvent, false);
  elem.addEventListener("touchmove", handleEvent, false);
  elem.addEventListener("touchend", handleEvent, false);
}

Swipe.prototype.touches = {
  touchstart: { x: -1, y: -1 },
  touchmove: { x: -1, y: -1 },
  touchend: false,
  direction: "undetermined",
};

Swipe.prototype.touchHandler = function (event) {
  var touch;
  if (typeof event !== "undefined") {
    if (typeof event.touches !== "undefined") {
      touch = event.touches[0];
      switch (event.type) {
        case "touchstart":
        case "touchmove":
          this.touches[event.type].x = touch.pageX;
          this.touches[event.type].y = touch.pageY;
          break;
        case "touchend":
          this.touches[event.type] = true;
          var x = this.touches.touchstart.x - this.touches.touchmove.x,
            y = this.touches.touchstart.y - this.touches.touchmove.y;
          if (x < 0) x /= -1;
          if (y < 0) y /= -1;
          if (x > y)
            this.touches.direction =
              this.touches.touchstart.x < this.touches.touchmove.x
                ? "right"
                : "left";
          else
            this.touches.direction =
              this.touches.touchstart.y < this.touches.touchmove.y
                ? "down"
                : "up";
          this.callback(event, this.touches.direction);
          break;
      }
    }
  }
};

export default class Lightbox {
  constructor({
    lazyload = true,
    counter = true,
    arrows = true,
    slideSpeed = 400,
    scope = null,  // NEW: Optional scope to limit lightbox to specific container
    ...options
  }) {
    if (!options.selector) {
      console.error(
        'Please add a valid css selector with the option "selector:"'
      );
    } else if (typeof options.selector !== "string") {
      console.error(
        options.selector,
        `is not a string but a(n) ${typeof options.selector}`
      );
    } else {
      this.selector = options.selector;
      this.lazyload = lazyload;
      this.counter = counter;
      this.arrows = arrows;
      this.slideSpeed = slideSpeed;
      this.scope = scope;

      // Support both 'a' tags and direct image elements
      // If scope is provided, only get images within that scope
      let aLinks = [];
      let imageElements = [];
      
      if (scope) {
        // Handle multiple matching scope elements (e.g., multiple expanded projects)
        const scopeElements = document.querySelectorAll(scope);
        
        if (scopeElements.length === 0) {
          console.error(`No scope elements found for '${scope}'`);
          return;
        }
        
        // Collect links from all matching scope elements
        scopeElements.forEach(scopeElement => {
          aLinks = aLinks.concat(Array.from(scopeElement.querySelectorAll(`a${options.selector}`)));
          imageElements = imageElements.concat(Array.from(scopeElement.querySelectorAll('.js-lightbox-image')));
        });
      } else {
        // No scope provided, search entire document
        aLinks = Array.from(document.querySelectorAll(`a${options.selector}`));
        imageElements = Array.from(document.querySelectorAll('.js-lightbox-image'));
      }
      
      this.links = [...aLinks, ...imageElements];
      
      // Create project mapping for context-aware lightbox
      this.projectMapping = this.createProjectMapping(this.links);
      this.offsets = [];
      this.nodes = {};
      this.imageIndex = null;
      if (this.links.length > 0) {
        this.createLightbox();
        this.createNodes();
        this.eventListeners(this.links);
      } else {
        console.log(
          `No lightbox triggers found within scope '${scope || 'document'}'`
        );
      }
    }
  }

  goTo = (num, event) => {
    const { items, counter, lightboxNode } = this.nodes;
    
    // Update project-aware counter and title
    this.updateProjectContext(num);
    
    if (this.counter && counter) {
      const currentProject = this.projectMapping[num];
      const projectImageCount = currentProject ? currentProject.imageCount : this.links.length;
      const projectImageIndex = currentProject ? currentProject.imageIndex : num;
      counter.innerHTML = `${projectImageIndex + 1}/${projectImageCount}`;
    }
    const spinner = `<div class="spinner"></div>`;
    const img = items[num].querySelector("img");
    // if (this.lazyload) {
    //   const src = img.getAttribute("data-src");
    //   items[num].insertAdjacentHTML("beforeend", spinner);
    //   // Set image attribute
    //   img.setAttribute("src", src);

    //   // Add class to slide item when image is completely loaded. Must be in this order.
    //   const imgLoad = new Image();
    //   imgLoad.onload = () => {
    //     items[num].classList.add("is-active");
    //     items[num].classList.add("is-loaded");
    //   };
    //   imgLoad.src = src;
    // } else {
    //   items[num].classList.add("is-active");
    //   items[num].classList.add("is-loaded");
    // }
    items[num].classList.add("is-active");
    items[num].classList.add("is-loaded");

    // Change the offset for each slide based on its index and the current index.
    for (let i = 0; i < this.offsets.length; i++) {
      const offset = this.offsets[i] - num * 100;

      items[i].style.transform = `translateX(${offset}vw)`;

      // Add transition type based on which event was triggered
      if (event) {
        if (event.target.className === "js-gallery-thumb") {
          items[i].style.transition = `opacity 0.4s ease`;
        } else {
          items[i].style.transition = `transform ${this.slideSpeed}ms ease-out`;
        }
      }
    }
  };

  createProjectMapping = (links) => {
    const mapping = {};
    const projectCounts = {};
    
    links.forEach((link, index) => {
      // Find which project this image belongs to
      const projectContainer = link.closest('.c-project');
      let projectId = 'default';
      let projectTitle = 'Gallery';
      
      if (projectContainer) {
        // Use data-project attribute or create ID from title
        const projectSlug = projectContainer.querySelector('.c-projects-list__item')?.getAttribute('data-project');
        const titleElement = projectContainer.querySelector('.c-projects-list__item__cell.title');
        
        if (projectSlug) {
          projectId = projectSlug;
        } else if (titleElement) {
          projectId = titleElement.textContent.trim().toLowerCase().replace(/\s+/g, '-');
        }
        
        if (titleElement) {
          projectTitle = titleElement.textContent.trim();
        }
      } else {
        // Check if we're on a project page
        const isProjectPage = document.body.classList.contains('page-project');
        if (isProjectPage) {
          const projectHeadingTitle = document.querySelector(".c-project-heading span:first-child");
          if (projectHeadingTitle) {
            projectTitle = projectHeadingTitle.textContent.trim();
            projectId = projectTitle.toLowerCase().replace(/\s+/g, '-');
          }
        }
      }
      
      // Initialize project count if not exists
      if (!projectCounts[projectId]) {
        projectCounts[projectId] = 0;
      }
      
      mapping[index] = {
        projectId: projectId,
        projectTitle: projectTitle,
        imageIndex: projectCounts[projectId],
        imageCount: 0 // Will be updated after counting all
      };
      
      projectCounts[projectId]++;
    });
    
    // Update image counts for each project
    Object.keys(mapping).forEach(index => {
      const projectId = mapping[index].projectId;
      mapping[index].imageCount = projectCounts[projectId];
    });
    
    return mapping;
  };

  updateProjectContext = (imageIndex) => {
    const titleElement = document.querySelector('.c-gallery-title');
    if (titleElement && this.projectMapping[imageIndex]) {
      titleElement.textContent = this.projectMapping[imageIndex].projectTitle;
    }
  };

  createNodes = (links) => {
    // Find all the lightbox nodes and add them to an object
    Object.assign(this.nodes, {
      lightboxNode: document.querySelector(".js-gallery"),
      items: Array.from(document.querySelectorAll(".js-gallery-slide")),
      next: document.querySelector(".js-gallery-next"),
      prev: document.querySelector(".js-gallery-prev"),
      close: document.querySelector(".js-gallery-close"),
    });

    Object.assign(this.nodes, {
      counter: document.querySelector(".js-gallery-counter"),
    });
  };

  eventListeners = (links) => {
    const { lightboxNode, items, next, prev, close } = this.nodes;
    
    // Store handlers for cleanup
    this.clickHandlers = [];
    
    links.forEach((item, index) => {
      // Create handler function
      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Lightbox click detected for image', index); // Debug log
        lightboxNode.classList.add("is-active");
        document.body.style.overflow = "hidden";
        this.imageIndex = index;
        this.goTo(index, e);
        this.setNav(index);
      };
      
      // Store handler reference
      this.clickHandlers.push({ element: item, handler });
      
      // Use capture phase to ensure we catch the event before Swiper
      item.addEventListener("click", handler, true);
    });

    next.addEventListener("click", (e) => {
      this.goToNext(e);
    });

    prev.addEventListener("click", (e) => {
      this.goToPrev(e);
    });

    close.addEventListener("click", () => {
      this.closeBox();
    });

    document.onkeydown = (e) => {
      switch (e.keyCode) {
        case 37:
          this.goToPrev(e);
          break;
        case 39:
          this.goToNext(e);
          break;
        case 27:
          this.closeBox();
          break;
      }
    };

    items.forEach((item) => {
      // https://gist.github.com/Tam/d44c87b3daeb07b15984ddc6127d4e34
      new Swipe(item.querySelector("img"), (e, direction) => {
        e.preventDefault();
        switch (direction) {
          case "up":
            // Handle Swipe Up
            break;
          case "down":
            // Handle Swipe Down
            break;
          case "left":
            this.goToNext(e);
            break;
          case "right":
            this.goToPrev(e);
            break;
        }
      });
    });
  };

  setNav = (index) => {
    if (this.arrows) {
      const { next, prev } = this.nodes;
      if (index < this.links.length - 1) {
        next.classList.add("is-active");
      }
      // if (index >= this.links.length - 1) {
      //   next.classList.remove("is-active");
      // }
      if (index > 0) {
        prev.classList.add("is-active");
      }
      if (index <= 0) {
        prev.classList.remove("is-active");
      }
    }
  };

  goToNext = (e) => {
    const { items } = this.nodes;
    if (this.imageIndex < items.length - 1) {
      const oldIndex = this.imageIndex;
      this.imageIndex += 1;
      this.goTo(this.imageIndex, e);
      setTimeout(() => {
        if (items[oldIndex]) {
          items[oldIndex].classList.remove("is-active");
        }
      }, this.slideSpeed);
      this.setNav(this.imageIndex);
    } else {
      // Loop back to first image
      const oldIndex = this.imageIndex;
      this.imageIndex = 0;
      this.goTo(this.imageIndex, e);
      setTimeout(() => {
        if (items[oldIndex]) {
          items[oldIndex].classList.remove("is-active");
        }
      }, this.slideSpeed);
      this.setNav(this.imageIndex);
    }
  };

  goToPrev = (e) => {
    const { items } = this.nodes;
    if (this.imageIndex > 0) {
      const oldIndex = this.imageIndex;
      this.imageIndex -= 1;
      this.goTo(this.imageIndex, e);
      setTimeout(() => {
        if (items[oldIndex]) {
          items[oldIndex].classList.remove("is-active");
        }
      }, this.slideSpeed);
      this.setNav(this.imageIndex);
    }
  };

  closeBox = () => {
    const { lightboxNode, items } = this.nodes;
    lightboxNode.classList.remove("is-active");
    document.body.style.overflow = "auto";
    setTimeout(() => {
      items.forEach((item) => item.classList.remove("is-active"));
    }, this.slideSpeed);
  };

  renderImages = (images) => {
    const imagesLinks = images.map((item, index) => {
      const offset = index * 100;
      this.offsets.push(offset);
      // Support multiple data attribute sources
      const caption = item.getAttribute("data-caption") || item.getAttribute("data-lightbox-caption") || '';
      const imageSrc = item.getAttribute("href") || item.getAttribute("data-lightbox-src") || item.getAttribute("data-src");
      const imageSrcset = item.getAttribute("data-lightbox-srcset") || item.getAttribute("data-srcset") || '';
      
      // Build srcset attribute if available
      const srcsetAttr = imageSrcset ? `srcset="${imageSrcset}"` : '';
      const sizesAttr = imageSrcset ? `sizes="100vw"` : '';
      
      return `
                <li class='c-gallery__slide js-gallery-slide' style='transform: translateX(${offset}vw)'>
                    <img src='${imageSrc}' ${srcsetAttr} ${sizesAttr} alt='${caption}'/>
                    ${caption ? `<figcaption class="t-small"><span>${caption}</span></figcaption>` : ''}
                </li>
            `;
    });
    return imagesLinks;
  };

  createLightbox = () => {
    // Remove existing lightbox if present
    const existingLightbox = document.querySelector('.js-gallery');
    if (existingLightbox) {
      existingLightbox.remove();
    }
    
    // Title will be set dynamically based on current image's project
    const lightbox = `
            <div class='c-gallery js-gallery'>
                <div class='c-gallery__controls t-small'>
                    <button class="c-gallery-close t-link js-gallery-close">Close</button>
                    <button class="c-gallery-arrow-area prev u-has-glyph u-has-glyph--left js-gallery-prev"></button>
                    <button class="c-gallery-arrow-area next u-has-glyph u-has-glyph--right js-gallery-next"></button>
                    <div class="c-gallery-title">Gallery</div>
                </div>
                <ul class='c-gallery__slider'>
                    ${this.renderImages(this.links).join("")}
                </ul>
                <div class='c-gallery__counter t-small js-gallery-counter'>
                </div>
            </div>
        `;
    document.querySelector("#main").insertAdjacentHTML("afterend", lightbox);
  };

  destroy = () => {
    // Remove event listeners
    if (this.clickHandlers) {
      this.clickHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler, true);
      });
    }
    
    // Remove lightbox DOM element
    const lightbox = document.querySelector('.js-gallery');
    if (lightbox) {
      lightbox.remove();
    }
    
    // Clear references
    this.links = [];
    this.nodes = {};
    this.offsets = [];
    this.clickHandlers = [];
  };
}

